import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import useStore from '@/store/useStore';

/**
 * NavigationEvents component handles navigation events within the appointment booking modal.
 * It updates the state based on the current pathname and search parameters.
 */
export function NavigationEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const setIsAppointmentBookingModalVisible = useStore(state => state.setIsAppointmentBookingModalVisible);
  const setInfo = useStore(state => state.setAppointmentBookingInformation);
  const info = useStore(state => state.appointmentBookingInformation);

  const emptyInfo = {
    modalName: '',
    displayName1: '',
    displayName2: '',
    addresLine1: '',
    addressLine2: '',
    id: '',
    city: '',
    state: '',
    zipCode: '',
    setsterLocationId: '',
    timezoneName: '',
    timezoneAbreviation: '',
    timezoneId: '',
  };

  useEffect(() => {
    if (info.successfullBooking) {
      setIsAppointmentBookingModalVisible(false);
      setInfo('successfullBooking', false);
      setInfo('selectedShowroomStore', emptyInfo);
      setInfo('prevSelectedShowroomStore', emptyInfo);
      setInfo('selectedServiceName', '');
      setInfo('selectedServiceId', '');
      setInfo('selectedServiceDateNightId', '');
      setInfo('selectedDate', null);
      setInfo('selectedTime', '');
      setInfo('selectedTimezone', '');
      setInfo('selectedTimezoneName', '');
      setInfo('selectedTimezoneId', '0');
      setInfo('setsterAvailabilityDateTimes', {});
      setInfo('setsterAvailabilityDateTimesLoading', true);
      setInfo('currentTimezone', '');
    }
    // ...
  }, [pathname, searchParams]);

  return '';
}
